import registerAWillImg from '../../assets/images/register-will-bg.webp';
import searchAWillImg from '../../assets/images/search-will-bg.webp';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';

const QuickLinks = () => {
  const WILL_REGISTRATION_URL = process.env.REACT_APP_WILL_REGISTRATION_URL;
  return (
    <div className="quick-links">
      <Row>
        <Col lg={12} sm={6} md={6} xs={12}>
          <div className="link-box">
            <Link to={`${WILL_REGISTRATION_URL}/find-a-missing-will`}>
              <img
                src={searchAWillImg}
                title="Find a missing or lost Will"
                alt="Find a missing or lost Will"
              />
              <span className="fow-button-outlined-orange px-3 w-100">
                FIND A WILL
              </span>
            </Link>
          </div>
        </Col>
        <Col lg={12} sm={6} md={6} xs={12}>
          <div className="link-box">
            <Link to={`${WILL_REGISTRATION_URL}/register-your-will`}>
              <img
                src={registerAWillImg}
                title="Register a will for free at The U.S. Will Registry"
                alt="Register a will for free at The U.S. Will Registry"
              />
              <span className="fow-button-outlined-orange px-3 w-100">
                REGISTER A WILL
              </span>
            </Link>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default QuickLinks;
